import {
  Badge, CircularProgress, ClickAwayListener, Grow,
  IconButton, Menu, MenuItem, MenuList, Paper, Popper
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { connect, useSelector } from "react-redux";
import ContentMenu from "./component/ContentMenu";
import Sidebar from "./component/Sidebar";
import Login from "./component/Login";
import { clearSession } from "./services/AuthenticationService";

import axios from "axios";
import { Route, Switch, withRouter } from "react-router-dom";
import "./App.css";
import Configuration from "./environment";
import { ChangePasswordComponent } from "./pages/ChangePassword";


class App extends React.Component {
  constructor(props) {
    super(props);
    this.handler = this.handler.bind(this);
    this.toggleMobileNav = this.toggleMobileNav.bind(this);
    this.closeMobileNav = this.closeMobileNav.bind(this);
    this.state = {
      choosedMenuItem: [
        { label: "Home", icon: "fa-home", onClick: this.backToHome },
      ],
      mobileNavOpen: false,
    };
  }

  toggleMobileNav() {
    this.setState((state) => ({ mobileNavOpen: !state.mobileNavOpen }));
  }

  closeMobileNav() {
    this.setState({ mobileNavOpen: false });
  }

  handler(menu) {
    let menus = menu.split(",").map((e) => {
      switch (e) {
        case "Dashboard":
          return { label: e, icon: "fa-dashboard" };
        case "Management":
          return { label: e, icon: "fa-cog" };
        case "Controller":
          return { label: e, icon: "fa-microchip" };
        case "PointOfSales":
          return { label: e, icon: "fa-map-marker" };
        case "Users":
          return { label: e, icon: "fa-user-circle-o" };
        case "Commands":
          return { label: e, icon: "fa-terminal" };
        case "Advertisement":
          return { label: e, icon: "fa-solid fa-rectangle-ad" };
        case "Resources":
          return { label: e, icon: "fa-file" };
        default:
          return {};
      }
    });

    this.setState(() => ({
      choosedMenuItem: [
        { label: "Home", icon: "fa-home", onClick: this.backToHome },
        ...menus,
      ],
      mobileNavOpen: false,
    }));
  }
  /**
   *
   * check if a token exist an its valid one
   *
   */
  checkTokenValidity = () => {
    if (this.props.history.location.pathname.startsWith("/change-password/")) {
      return;
    }
    if (this.props.history.location.pathname !== "/login") {
      if (localStorage.getItem("token") === null) {
        this.props.history.push("/login");
      } else {
        // check if token is valid
        let isValid =
          Date.now() <
          JSON.parse(
            atob(
              localStorage
                .getItem("token")
                .replace("Bearer", "")
                .trim()
                .split(".")[1]
            )
          ).exp *
            1000;
        if (
          isValid &&
          this.props.history.location.pathname !== "/login" &&
          this.props.history.location.pathname !== "/home"
        ) {
          this.props.history.push("/home");
        } else if (
          isValid &&
          this.props.history.location.pathname === "/home"
        ) {
        } else {
          // do nothing
          this.props.history.push("/login");
        }
      }
    }
  };

  backToHome = () => {
    this.setState(() => ({
      choosedMenuItem: [{ label: "Home", icon: "fa-home" }],
    }));
  };

  render() {
    this.checkTokenValidity();
    return (
      <div className="App">
        <Loader />
        <Switch>
          <Route path="/change-password/:checksum" component={ChangePasswordComponent}  />
          <Route path="/login">
            <Login />
          </Route>
          <Route path="/home">
            {this.checkTokenValidity()}
            <div className="app-shell">
              <Sidebar
                chooseMenu={this.handler}
                choosedMenu={this.state.choosedMenuItem}
                onHome={this.backToHome}
                open={this.state.mobileNavOpen}
              />
              {this.state.mobileNavOpen && (
                <div
                  className="sidebar-backdrop"
                  onClick={this.closeMobileNav}
                ></div>
              )}
              <div className="app-content">
                <div className="app-topbar">
                  <IconButton
                    className="mobile-nav-toggle"
                    onClick={this.toggleMobileNav}
                    aria-label="Ouvrir le menu"
                  >
                    <i className="fa fa-bars" />
                  </IconButton>
                  <NotificationComponent />
                  <UserSectionComponent />
                </div>
                <div className="Body">
                  <ContentMenu
                    choosedMenu={this.state.choosedMenuItem}
                  ></ContentMenu>
                </div>
              </div>
            </div>
          </Route>
        </Switch>
      </div>
    );
  }
}

const Loader = (props) => {
  const hide = useSelector((state) => state.loadingReducer);

  return (
    <div
      className={hide ? "" : "hide"}
      id="ajaxLoader"
      style={{
        display: "flex",
        flexDirection: "column",
        justifyItems: "center",
        justifyContent: "center",
        position: "fixed",
        zIndex: "10010",
        width: "100vw",
        height: "100vh",
        background: "#00000052",
      }}
    >
      <CircularProgress
        style={{
          width: "100px",
          height: "100px",
          margin: "auto",
          color: "#0000007d",
        }}
      />
    </div>
  );
};

const UserSectionComponent = (props) => {
 
  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef(null);

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    setOpen(false);
  };

  const logOut = () => {
    clearSession();
    window.location.reload();
  };

  function handleListKeyDown(event) {
    if (event.key === "Tab") {
      event.preventDefault();
      setOpen(false);
    }
  }

  // return focus to the button when we transitioned from !open -> open
  const prevOpen = React.useRef(open);
  React.useEffect(() => {
    if (prevOpen.current === true && open === false) {
      anchorRef.current.focus();
    }

    prevOpen.current = open;
  }, [open]);

  const username = localStorage.getItem("user") || "";
  const userPic = localStorage.getItem("userPic");
  const hasRealPic = userPic !== "undefined" && userPic !== null && userPic !== "";
  const initials = username.slice(0, 2).toUpperCase() || "?";

  return (
    <div className="user-section">
      <IconButton
        ref={anchorRef}
        aria-controls={open ? "menu-list-grow" : undefined}
        aria-haspopup="true"
        onClick={handleToggle}
      >
        {hasRealPic ? (
          <img id="userProfilePic" src={userPic} alt="" />
        ) : (
          <span className="user-avatar-initials">{initials}</span>
        )}
      </IconButton>
      <Popper
        open={open}
        anchorEl={anchorRef.current}
        role={undefined}
        transition
        className="app-popper"
      >
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin:
                placement === "bottom" ? "center top" : "center bottom",
            }}
          >
            <Paper className="user-menu-paper">
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList
                  autoFocusItem={open}
                  id="menu-list-grow"
                  onKeyDown={handleListKeyDown}
                  className="user-menu-list"
                >
                  <li className="user-menu-header">
                    <span className="user-avatar-initials">{initials}</span>
                    <span id="username" className="user-menu-name">
                      {username}
                    </span>
                  </li>
                  <MenuItem onClick={logOut} className="user-menu-logout">
                    <i className="fa fa-sign-out" />
                    <span>Déconnexion</span>
                  </MenuItem>
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </div>
  );
};

const NotificationComponent = (props) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const [badgeContent, setBadgeContent] = useState({});
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  useEffect(() => {
    setInterval(() => {
      axios
        .get(
          Configuration.backend_api_url +
            "/controllers/health-status/notification",
          {
            headers: {
              authorization: localStorage.getItem("token"),
            },
          }
        )
        .then((resp) => {
          setBadgeContent(resp.data);
        });
    }, 30 * 1000);
  }, []);

  return (
    <div className="notification-section">
      <IconButton onClick={handleClick}>
        <Badge
          badgeContent={Object.keys(badgeContent).length}
          max={999}
          color="secondary"
        >
          <i className="fa fa-bell" />
        </Badge>
      </IconButton>
      <Menu id="notification-menu"
        className="app-popper"
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        anchorEl={anchorEl}
        open={open}
        placement="bottom-start"
        onClose={handleClose}
      >
        <div className="notification-menu-content">
          <span className="header">Notification</span>
          {Object.keys(badgeContent).map((k,index) => (
            <MenuItem key={index}>
            <i className="fa fa-exclamation-triangle" />
              <span>{k +" seem not to be OK, threshold: " +
                badgeContent[k]}</span>
            </MenuItem>
          ))}
          {Object.keys(badgeContent).length === 0 ? (
              <div className="no-msg-content">Nothing to highlight</div>
          ) : (
            ""
          )}
        </div>
      </Menu>
    </div>
  );
};

const mapStateToProps = state => ({
  wipEnabled : state.wipEnabledReducer.enabled
})

export default withRouter(connect(mapStateToProps,null)(App));
